import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudService } from 'src/app/services/crud.service';
import { ToastrService } from 'ngx-toastr';
import { DeleteConfirmationComponent } from 'src/app/layout/modals/delete-confirmation/delete-confirmation.component';
import { CreateAffiliateCodeComponent } from '../create-affiliate-code/create-affiliate-code.component';


@Component({
  selector: 'app-affiliate-code',
  templateUrl: './affiliate-code.component.html',
  styleUrl: './affiliate-code.component.css'
})
export class AffiliateCodeComponent {
  affiliateCodeData: any = [];
  spinners: boolean = false;
  page: number = 1;
  limit: number = 10;
  paramsValue:any;

  constructor(
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute,
    private urlService: CrudService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.paramsValue = queryParams;
    });
    this.getAllAffiliateCode(true);
  }

  getAllAffiliateCode(reset?){
    if (reset) {
      this.page = 1;
      this.affiliateCodeData = [];
    }
    this.spinners = true;
    this.urlService.getAffiliateCode({page: this.page, limit: this.limit}).subscribe((res: any) => {
      const allAffiliateCode = res.data || [];
      allAffiliateCode.forEach((code) => {
        if (code) {
          this.affiliateCodeData.push(code);
        }
      });
      this.spinners = false;
    }, (err) => {
      this.spinners = false;
      this.toastr.error('Fetching affiliate codes Failed');
    })
  }

  onScrollAffiliateCode() {
    ++this.page;
    this.getAllAffiliateCode(false);
  }

  createAffiliateCode(data?:any) {
    const dialogRef = this.dialog.open(CreateAffiliateCodeComponent, {
      width: '100%',
      maxWidth: '800px',
      // maxHeight: '600px',
      panelClass: 'my-dialog',
      height: 'auto',
      data: {
        codeData: data ? data : '',
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAllAffiliateCode(true);
      }
    });
  }

  editaffiliateCode(data:any) {
    this.createAffiliateCode(data);
  }
}
